import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=1f4a01c8"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=1f4a01c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports